
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'default' | 'white';
  hideText?: boolean;
}

export const Logo = ({
  className,
  size = 'md',
  variant = 'default',
  hideText = false
}: LogoProps) => {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-3xl',
    lg: 'text-4xl',
    xl: 'text-5xl',
  };

  const iconSizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  return (
    <div className={cn("flex items-center gap-3", className)}>
      {/* Isotipo */}
      <img 
        src="https://i.postimg.cc/BbJ7Gy7K/metrocalma-iso.png" 
        alt="MetroCalma Isotipo" 
        className={cn("object-contain", iconSizeClasses[size])}
      />
      
      {/* Texto da logo */}
      {!hideText && (
        <span className={cn(
          "brand-text font-spartan font-bold",
          sizeClasses[size],
          variant === 'white' ? 'text-white' : 'text-brand-primary'
        )}>
          metrocalma
        </span>
      )}
    </div>
  );
};
